<div class="ER mdc-elevation--z2">
    <div class="ER__back" v-if="step > 0 && step < 5" @click="goBack"><mom-icon svgIcon="arrow"></mom-icon><span>back</span></div>
    <component :is="selectedView" :resourceBaseUrl="resourceBaseUrl" :orgData="orgData" :verifyEmailData="verifyEmailData" @next="onStateComplete"></component>
</div>
